<div class="flex h-full justify-center items-center">
  <div class="flex flex-col justify-center items-center p-4 z-50 rounded-md">
    <mat-spinner [diameter]="48"></mat-spinner>
    <div class="pt-4">Signing out...</div>
  </div>
</div>
